import { CommonButton } from '../../components/buttons';
import {
  change,
  Field,
  FieldArray,
  formValueSelector,
  reduxForm,
} from 'redux-form';
import {
  getMasterData,
  getPatientInsurancesDetails,
  saveInsuranceDetails,
} from './actions/PatientActions';
import {
  isValidApartmentWithSpace,
  isValidFileType,
  isValidName,
  isValidNameWithSpace,
  normalizeMobile,
  normalizeZipCode,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderDateField,
  renderTextArea,
  renderTextField,
} from '../../components/reduxFields';
import { connect } from 'react-redux';
import moment from 'moment';
import React from 'react';
import Alert from 'react-s-alert';
import GooglePlaceAutocomplete from '../../components/GooglePlaceAutocomplete';
import { CONVERGENCY, extractDataFromArrayByValue, formatDate, showErrorMessage, showWarningMessage } from '../../actions/utilAction';
import InsuranceCollapse from './InsuranceCollapse';

// import validate from './validate';
const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  uploadButton: {
    verticalAlign: 'middle',
  },
  removeImageBtn: {
    border: 'none',
    padding: 7,
    width: 35,
    borderRadius: 54,
    marginLeft: 11,
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
  font: {
    fontStyle: 'ITALIC',
  },
};
let  INSURANCETYPE = "primary"
const validate = (values) => {
  const error = {};

  if (values.insurance && values.insurance.length) {
    const insuranceArrayErrors = [];
    values.insurance.forEach((insuranceObj, index) => {
      const insuranceErrors = {
        insuredPerson: {},
      };
      const insuranceCompaniesArray = values.insurance.map((obj) => obj.insuranceCompanyID);
     ///////////
      // if(values.insurance && values.insurance.length){
      //   let companyIds = [];
      //   values.insurance.forEach((value,i) => {
      //     console.log("valueeeeeeee",value)
      //     if(value && value.insuranceIDNumber){
      //       companyIds.push(value.insuranceIDNumber)
      //     }
      //   })
      //   let insIndex = companyIds.findIndex((obj) => obj === insuranceObj.insuranceIDNumber);
      //   if(insIndex > -1 && insIndex !== index){
      //     insuranceErrors.insuranceIDNumber = 'Please enter unique Insurance Company Id';
      //     insuranceArrayErrors[index] = insuranceErrors;
      //   }
      // }
    ///////////
    let previousDate = null
    let currentDate = null
    if(index>1){
      previousDate = new Date(values.insurance[index - 1].cardIssueDate);
      currentDate = new Date(values.insurance[index].cardIssueDate);
    }
        
    if(currentDate < previousDate){
       insuranceErrors.cardIssueDate="Please Select Insurance issue date in chronological Order"
    }  
      if(insuranceObj && insuranceObj.cardIssueDate && insuranceObj.cardIssueEndDate ){
        let issDate = new Date(insuranceObj.cardIssueDate);
        let endDate = new Date(insuranceObj.cardIssueEndDate);
        if(issDate > endDate){
          insuranceErrors.cardIssueEndDate = 'Please extend the End Date';
          // showWarningMessage('Please extend the End Date');
        }else {
           insuranceErrors.cardIssueEndDate = null
        }
        insuranceArrayErrors[index] = insuranceErrors;
    }
    
    
    if(INSURANCETYPE==="secondary"){
      if(insuranceObj && !insuranceObj.cardIssueDate && index>0){
        insuranceErrors.cardIssueDate = 'Please Select Card Issue Date';
      }  
      else{
        insuranceErrors.cardIssueDate = null
    }
  }

      if (!insuranceObj || !insuranceObj.insuranceCompanyID) {
        insuranceErrors.insuranceCompanyID = 'Please select insurance company';
        insuranceArrayErrors[index] = insuranceErrors;
      } 
      // else {
      //   let insIndex = insuranceCompaniesArray.findIndex((obj) => obj === insuranceObj.insuranceCompanyID);
      //   if (insIndex > -1 && insIndex !== index) {
      //     insuranceErrors.insuranceCompanyID = 'Please select another insurance company';
      //     insuranceArrayErrors[index] = insuranceErrors;
      //   }
      // }
      // if (!insuranceObj || !insuranceObj.insuranceGroupName) {
      //   insuranceErrors.insuranceGroupName = 'Please enter Insurance group name';
      //   insuranceArrayErrors[index] = insuranceErrors;
      // }
      // if (!insuranceObj || !insuranceObj.insurancePlanName) {
      //   insuranceErrors.insurancePlanName = 'Please enter Insurance plan name';
      //   insuranceArrayErrors[index] = insuranceErrors;
      // }
     if (!insuranceObj || !insuranceObj.insuranceIDNumber) {
        insuranceErrors.insuranceIDNumber = 'Please enter insurance id number';
        insuranceArrayErrors[index] = insuranceErrors;
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.phone) {
        insuranceErrors.insuredPerson.phone = 'Please enter phone number';
      } else if (insuranceObj.insuredPerson && (insuranceObj.insuredPerson.phone || '').length < 14) {
        insuranceErrors.insuredPerson.phone = 'Please enter valid phone number';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.firstName) {
        insuranceErrors.insuredPerson.firstName = 'Please enter first name';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.lastName) {
        insuranceErrors.insuredPerson.lastName = 'Please enter last name';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.city) {
        insuranceErrors.insuredPerson.city = 'Please enter city';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.otherRelationshipName) {
        insuranceErrors.insuredPerson.otherRelationshipName = 'Please enter other relationship name';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.relationshipID) {
        insuranceErrors.insuredPerson.relationshipID = 'Please enter relationship';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.patientRelationshipBox6Id) {
        insuranceErrors.insuredPerson.patientRelationshipBox6Id = 'Please enter relationship status';
      }      
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.dob) {
        insuranceErrors.insuredPerson.dob = 'Please select date of birth';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.genderID) {
        insuranceErrors.insuredPerson.genderID = 'Please enter gender';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.stateID) {
        insuranceErrors.insuredPerson.stateID = 'Please enter state';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.countryID) {
        insuranceErrors.insuredPerson.countryID = 'Please enter country';
      }
      if (!insuranceObj.insuredPerson || !insuranceObj.insuredPerson.zip) {
        insuranceErrors.insuredPerson.zip = 'Please enter zip';
      } else if (insuranceObj.insuredPerson && (insuranceObj.insuredPerson.zip || '').length < 5) {
        insuranceErrors.insuredPerson.zip = 'Please enter correct zip code';
      }
      insuranceArrayErrors[index] = insuranceErrors;
    });
    if (insuranceArrayErrors.length) {
      error.insurance = insuranceArrayErrors;
    }
  }

  return error;
};

class InsuranceForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      insuranceCompanies: [],
      insurancePlanType: [],
      cardIssueDate: null,
      CardIssueEndDate: null,
      authorizedReleasedDate: new Date(),      
      dob: null,
      files: [],
      validImageError: null,
      imageFrontPreviewUrl: [],
      imageBackPreviewUrl: [],
      patientId: props.patientId,
      FrontImage: '',
      BackImage: '',
      relationship: [],
      masterGender: [],
      masterState: [],
      masterStateByCountryId: [],
      masterCountry: [],
      filteredStatesByCountry: [],
      isTabChangeRequest: false,
      street_number: '',
      route: '',
      locality: '',
      administrative_area_level_1: '',
      country: '',
      postal_code: '',
      latitude: 0.0,
      longitude: 0.0,
      isValidAddress: true,
      Address: null,
      InsuredPersonsAddressList: [],
      sameSelectedInsureanceIndexsObject:{},
      collapseErrors: null,
      showToopTips: null,
      savedFieldData: {},
      isAddNewInsurance: false,
      isAddCollapse : false
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.GetFullAddress = this.GetFullAddress.bind(this);
    this.renderInsuranceDetails = this.renderInsuranceDetails.bind(this);
    this.IsFullAddressEmpty = this.IsFullAddressEmpty.bind(this);
    this.formRef = null;
    this.setFormRef = element => {
      this.formRef = element;
    };
  }
  componentWillReceiveProps(nextProps, nextState) {
    INSURANCETYPE = nextProps.insuranceType
    if (nextProps.patientMasterData && nextProps.patientMasterData !== this.props.patientMasterData) {
      let masterData = nextProps.patientMasterData;
      // auto fill the primary and mailing states by the default country id = 1 (usa) ..
      // let filteredStatesByCountry = [];
      // if (masterData.masterState) {
      //   filteredStatesByCountry = masterData.masterState.filter((obj) => obj.countryID === 1);
      // }

      if (nextProps.initialValues && nextProps.initialValues.insurance) {
        (nextProps.initialValues.insurance || []).forEach((obj, index) => {
          this.getFilteredStatesList(obj.insuredPerson && obj.insuredPerson.countryID, index);
        });
      }
      this.setState({
        insuranceCompanies: masterData.insuranceCompanies,
        insurancePlanType: masterData.insurancePlanType,
        relationship: masterData.masterRelationship,
        masterGender: masterData.masterGender,
        masterState: masterData.masterState,
        masterCountry: masterData.masterCountry,
        // filteredStatesByCountry: filteredStatesByCountry,
      });

    }

    if (nextProps.currentInsuranceDetails && nextProps.currentInsuranceDetails !== this.props.currentInsuranceDetails) {
      if (nextProps.currentInsuranceDetails.insurance) {
        let InsuredPersonsAddressList = [];
        InsuredPersonsAddressList = (nextProps.currentInsuranceDetails.insurance || []).map((obj, index) => {
          this.getFilteredStatesList(obj.insuredPerson && obj.insuredPerson.countryID, index);
          return {
            address: (obj.insuredPerson && obj.insuredPerson.address1) || '',
            latitude: (obj.insuredPerson && obj.insuredPerson.latitude) || 0.0,
            longitude: (obj.insuredPerson && obj.insuredPerson.longitude) || 0.0,
          };
        });
        this.setState({
          InsuredPersonsAddressList,
        });
      }
    }
    if (nextProps.saved_patientInsuranceDetails && nextProps.saved_patientInsuranceDetails !== this.props.saved_patientInsuranceDetails) {
      if (this.state.isTabChangeRequest) {
        this.setState({ isTabChangeRequest: false });
        this.props.handlePatientTabChange('5');
      } else {
        this.props.getPatientInsurancesDetails(this.state.patientId);
      }
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.initialValues.insurance !== this.props.initialValues.insurance){
      let insurances = this._deepClonnigMethod(this.props.initialValues.insurance); 
      if(insurances.length){
        this._createMapWithInsurenceNameWithIteratedIndexes(insurances);
      }
    }

    if (JSON.stringify(this.props.selectorInsuranceDetail) !== JSON.stringify(prevProps.selectorInsuranceDetail)) {   
      const insuranceList = this.props.selectorInsuranceDetail;
    
      if (insuranceList.length) {
        insuranceList.forEach((currentObj, currentIndex) => {
          // Reset current cardIssueEndDate first
          // this.props.dispatch(
          //   change('InsuranceForm', `insurance[${currentIndex}].cardIssueEndDate`, null)
          // );
    
          // If first index and secondary type, clear cardIssueDate
          if (currentIndex === 0 && this.props.insuranceType === "secondary") {
            this.props.dispatch(
              change('InsuranceForm', `insurance[${currentIndex}].cardIssueDate`, null)
            );
          }
    
          // Find previous matching insuranceCompanyID
          for (let prevIndex = currentIndex - 1; prevIndex >= 0; prevIndex--) {
            const prevObj = insuranceList[prevIndex];
            if (prevObj.insuranceCompanyID === currentObj.insuranceCompanyID) {
              const cardIssueDate = currentObj.cardIssueDate;
              const nextCardIssueDate = new Date(cardIssueDate);
    
              if (isNaN(nextCardIssueDate.getTime())) {
                console.error(`Invalid cardIssueDate at index ${currentIndex}:`, cardIssueDate);
                break;
              }
    
              nextCardIssueDate.setDate(nextCardIssueDate.getDate() - 1);
    
              const year = nextCardIssueDate.getFullYear();
              const month = String(nextCardIssueDate.getMonth() + 1).padStart(2, '0');
              const day = String(nextCardIssueDate.getDate()).padStart(2, '0');
              const hours = String(nextCardIssueDate.getHours()).padStart(2, '0');
              const minutes = String(nextCardIssueDate.getMinutes()).padStart(2, '0');
              const seconds = String(nextCardIssueDate.getSeconds()).padStart(2, '0');
    
              const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    
              this.props.dispatch(
                change('InsuranceForm', `insurance[${prevIndex}].cardIssueEndDate`, formattedDate)
              );
              break; // Only update the immediate previous match
            }
          }
        });
      }
    }
   
  }



  _deepClonnigMethod(arr){
    let stringifiedArr = JSON.stringify(arr);
    let parsedArr = JSON.parse(stringifiedArr);
    return parsedArr;
  }

  
  IsFullAddressEmpty(searchText)
  {
    if(searchText.length === 0)
      this.setState({isValidAddress: false});    
  }

  GetFullAddress(componentForm, insIndex) {
    this.setState({
      street_number: componentForm.street_number,
      route: componentForm.route,
      locality: componentForm.locality,
      administrative_area_level_1: componentForm.administrative_area_level_1,
      country: componentForm.country,
      postal_code: componentForm.postal_code,
      latitude: componentForm.lat,
      longitude: componentForm.lng,
      isValidAddress: true,
    }, () => {
      this.props.dispatch(change('InsuranceForm', `insurance[${insIndex}].insuredPerson.city`, this.state.locality === 'long_name' ? '' : this.state.locality));
      this.props.dispatch(change('InsuranceForm', `insurance[${insIndex}].insuredPerson.zip`, this.state.postal_code === 'short_name' ? '' : this.state.postal_code));
      let countryObj = extractDataFromArrayByValue(this.state.masterCountry, this.state.country === 'short_name' ? '' : this.state.country, true);
      if (countryObj) {
        this.props.dispatch(change('InsuranceForm', `insurance[${insIndex}].insuredPerson.countryID`, countryObj.id));
        this.getFilteredStatesList(countryObj.id, insIndex);
      }
      let stateObj = extractDataFromArrayByValue(this.state.filteredStatesByCountry[insIndex], this.state.administrative_area_level_1 === 'short_name' ? '' : this.state.administrative_area_level_1, false);
      if (stateObj) {
        this.props.dispatch(change('InsuranceForm', `insurance[${insIndex}].insuredPerson.stateID`, stateObj.id));
      }
      let Address = this.state.street_number === 'short_name' && this.state.route === 'long_name' ? '' :
        this.state.street_number === 'short_name' ? this.state.route : this.state.street_number + ' ' + this.state.route;
      // this.setState({ Address: Address });
      let InsuredPersonsAddressList = this.state.InsuredPersonsAddressList;
      InsuredPersonsAddressList[insIndex] = {
        address: Address || '',
        latitude: this.state.latitude || 0.0,
        longitude: this.state.longitude || 0.0,
      };
      this.setState({ InsuredPersonsAddressList });
    });
  }

  onDateChange = (input, value, index ) => {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value },()=>{
      this.customValidation(index, this.props.selectorInsuranceDetail[index].insuranceCompanyName?this.props.selectorInsuranceDetail[index].insuranceCompanyName:'');
    });
  };

  isValidFileType(fName, fType) {
    let extentionLists = {}; // Create an object for all extension lists
    extentionLists.image = ['jpg', 'gif', 'bmp', 'png'];
    extentionLists.pdf = ['pdf'];
    return extentionLists[fType].indexOf(fName.split('.').pop()) > -1;
  }

  _handleImageChange(e, type, insIndex) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    /* if (!this.isValidFileType(file.name, 'image')) {
          // console.log('Please select a valid image');
          // this.setState({ validImageError: 'only jpeg, jpg, gif, bmp, png image type allowed.' });
    }*/
    reader.onloadend = () => {
      if (type === 'front') {
        let imagePreviewArray = this.state.imageFrontPreviewUrl;
        imagePreviewArray[insIndex] = reader.result;
        this.setState({
          imageFrontPreviewUrl: imagePreviewArray,
          FrontImage: e.target.files[0].name,
        });
        this.props.dispatch(change('InsuranceForm', `insurance[${insIndex}].insurancePhotoPathThumbFront`, reader.result));
      } else {
        let imagePreviewArray = this.state.imageBackPreviewUrl;
        imagePreviewArray[insIndex] = reader.result;
        this.setState({
          imageBackPreviewUrl: imagePreviewArray,
          BackImage: e.target.files[0].name,
        });
        this.props.dispatch(change('InsuranceForm', `insurance[${insIndex}].insurancePhotoPathThumbBack`, reader.result));
      }
    };
    if (file) {
      let isValidTypeImage = isValidFileType(file.name, 'image');
      if (!isValidTypeImage) {
        showWarningMessage('Please select a valid type image');
      } else {
        Alert.closeAll();
        reader.readAsDataURL(file);
      }
      // e.target.value = null;
    }
  }

  handleRemoveImage = (e, type, insIndex) => {
    e.preventDefault();
    if (type === 'front') {
      let imagePreviewArray = this.state.imageFrontPreviewUrl;
      imagePreviewArray[insIndex] = '';
      this.setState({ imageBackPreviewUrl: imagePreviewArray });
      this.props.dispatch(change('InsuranceForm', `insurance[${insIndex}].insurancePhotoPathThumbFront`, ''));
    } else if (type === 'back') {
      let imagePreviewArray = this.state.imageBackPreviewUrl;
      imagePreviewArray[insIndex] = '';
      this.setState({ imageFrontPreviewUrl: imagePreviewArray });
      this.props.dispatch(change('InsuranceForm', `insurance[${insIndex}].insurancePhotoPathThumbBack`, ''));
    }
  };


  showUploadedFileName() {
    if (this.state.FrontImage.File) {
      return (
        <p>
          {this.state.FrontImage.File.name}
          <br />
        </p>
      );
    }
  }

  handleNewRequest = (input, selectedRecord, insurance = '') => {
    let selectedField = input.name;
    let selectedValueId = selectedRecord.value;
    if (selectedField === `${insurance}.insuranceCompanyID`) {
      let insuranceObj = (this.state.insuranceCompanies || []).find((obj) => obj.id === selectedValueId);
      let companyAddress = null, carrierPayerID = null, tplCode = null;
      if (insuranceObj) {
        companyAddress = insuranceObj.address
        + (insuranceObj.apartmentNumber ? ' ' + insuranceObj.apartmentNumber : '')
        + (insuranceObj.city ? ' ' + insuranceObj.city : '')
        + (insuranceObj.masterState.stateAbbr ? ' ' + insuranceObj.masterState.stateAbbr : '')
        + (insuranceObj.masterCountry.countryName ? ' ' + insuranceObj.masterCountry.countryName : '')
        + (insuranceObj.zip ? ' ' + insuranceObj.zip : '');
        carrierPayerID = insuranceObj.carrierPayerID;
        tplCode = insuranceObj.tplCode;
      }
      // this.setState({ Address: companyAddress });
      this.props.dispatch(change('InsuranceForm', `${insurance}.insuranceCompanyAddress`, companyAddress));
      this.props.dispatch(change('InsuranceForm', `${insurance}.carrierPayerID`, carrierPayerID));
      this.props.dispatch(change('InsuranceForm', `${insurance}.TPLCode`, tplCode));
    }
    if (input.name === `${insurance}.insuredPerson.countryID`) {
      this.getFilteredStatesList(selectedRecord.value);
    }
    input.onChange(selectedRecord.value);
  };
  getFilteredStatesList = (countryID, insIndex) => {
    this.setState((prevState, props) => {
      let allStates = props.patientMasterData ? props.patientMasterData.masterState : [];
      if (allStates && allStates.length) {
        let filteredStates = allStates.filter((Obj) => Obj.countryID === countryID);
        let filteredStatesByCountry = this.state.filteredStatesByCountry;
        filteredStatesByCountry[insIndex] = filteredStates;
        return {
          filteredStatesByCountry,
        };
      }
    });
  }

  customValidation(index,selectedIns){
    // console.log("index",index);
    // console.log("customValidation",this.props.selectorInsuranceDetail);
    // console.log("state-->",this.state);
    let prevInsurance = null;
    let prevStartDate = null;
    let prevExpDate = null;
    
    let insurance = null;
    let startDate = null;
    let expDate = null;
    
    let key = `field${index}-prev`;
    // console.log("value", this.state.savedFieldData[key]);

    // if(this.props.selectorInsuranceDetail && this.props.selectorInsuranceDetail[index]){
    // console.log("first if customValidation");
    insurance  = this.props.selectorInsuranceDetail[index];
    startDate = insurance.cardIssueDate;
    expDate = insurance.cardIssueEndDate; 
    // } 
    // else {
    //   console.log("first else");
    //   return;
    // }

    let prevIndex = this.state.savedFieldData[key];
    if(this.props.selectorInsuranceDetail[prevIndex]){
      prevInsurance = this.props.selectorInsuranceDetail[prevIndex];
      // console.log("prevInsurance---->",this.props.selectorInsuranceDetail[prevIndex]);
      prevStartDate = prevInsurance.cardIssueDate;
      prevExpDate = prevInsurance.cardIssueEndDate
    }

    
    let fieldKey = `field-${index}`;

    let obj = {...this.state.collapseErrors};
    delete obj[fieldKey];
    let obj2 = {...this.state.showToopTips};
    delete obj2[fieldKey]
    this.setState({
      collapseErrors: { ...obj},
      showToopTips: {...obj2}
    },()=>{
      if(prevInsurance){
        // console.log("prevInsurance",prevInsurance);
        // console.log("newInsurance",insurance)
          
          if(!prevStartDate && prevExpDate){
            this.setState({collapseErrors:{
              ...this.state.collapseErrors,
              [fieldKey]: "invalid"
            }}, () => {
              this.checkDateInValid();
            }
            )
          }else if(prevStartDate && !prevExpDate){
            this.setState({collapseErrors:{
              ...this.state.collapseErrors,
              [fieldKey]: "invalid"
            }}, () => {
              this.checkDateInValid();
            }
            )
          }else if(!prevStartDate && !prevExpDate){
            this.setState({collapseErrors:{
              ...this.state.collapseErrors,
              [fieldKey]: "invalid"
            }}, () => {
              this.checkDateInValid();
            }
            )
          }else {
            // if(!startDate && expDate){
            //   this.setState({collapseErrors:{
            //     ...this.state.collapseErrors,
            //     [fieldKey]: "invalid"
            //   }}
            //   , () => {
            //     this.checkDateInValid();
            //   }
            //   )
            // }else if(!startDate && expDate){
            //   this.setState({collapseErrors:{
            //     ...obj,
            //     [fieldKey]: "invalid"
            //   }}, () => {
            //     this.checkDateInValid();
            //   }
            //   )
            // }else if(!startDate && !expDate){
            //   this.setState({collapseErrors:{
            //     ...obj,
            //     [fieldKey]: "invalid"
            //   }}, () => {
            //     this.checkDateInValid();
            //   }
            //   )
            // }else {
            //   this.setState({collapseErrors:{
            //     ...obj,
            //     [fieldKey]: "valid"
            //   }}, () => {
            //     this.checkDateInValid();
            //   }
            //   )
            // }
            this.setState({collapseErrors:{
              ...obj,
              [fieldKey]: "valid"
            }}, () => {
              this.checkDateInValid();
            }
            )
          }
          
        }else{
          // if( this.props.selectorInsuranceDetail && this.props.selectorInsuranceDetail.length){
          //   console.log("inside if SelectorInsuranceDetail", this.props.selectorInsuranceDetail,"-- selectedIns",selectedIns);
            
          //   let insDetail = this.props.selectorInsuranceDetail;
          //   console.log("insDetail",insDetail)
            
          if(startDate && expDate){
              let filterDatas = Object.keys(this.state.savedFieldData).filter(key=>this.state.savedFieldData[key] == selectedIns);
              let newInd={};
              filterDatas.forEach(key=>{
                let arr = key.split('-')[0].split("");
                let inn = arr[arr.length-1];
                let mykey = `field-${inn}`;
                newInd[mykey] = "valid";
              })

              this.setState({
                collapseErrors: {
                  ...this.state.collapseErrors,
                  ...newInd
                }
              },()=>{
                this.checkDateInValid();
              })
            }
        }
    })
    
  }

  handleSaveContinue = (formData) => {
    this.onSubmit(formData);
    this.setState({ isTabChangeRequest: true });
  };

  onSubmit(formData) {
    // Set InsurancePlanTypeID.

    this.setState({
      collapseErrors:null,
      showToopTips: null,
      savedFieldData: {},
      isAddNewInsurance:false
    });

    let insPlanTypeId = null;

    switch (this.props.insuranceType) {
    case 'primary':
      insPlanTypeId = this.props.primaryInsPlanTypeId;
      break;
    case 'secondary':
      insPlanTypeId = this.props.secondaryInsPlanTypeId;
      break;
    case 'tertiary':
      insPlanTypeId = this.props.tertiaryInsPlanTypeId;
      break;
    default:
      insPlanTypeId = null;
    }

    let insuranceData = [];

    insuranceData = formData.insurance.map((obj, index) => {
      let insuredPerson = null;
      if (!obj.insurancePersonSameAsPatient) {
        insuredPerson = {
          ...obj.insuredPerson,
          id: (obj.insuredPerson && obj.insuredPerson.id) || 0,
          patientID: this.props.patientId,
          dob: formatDate(obj.insuredPerson.dob),
          address1: (this.state.InsuredPersonsAddressList[index] && this.state.InsuredPersonsAddressList[index].address) || '',
          latitude: (this.state.InsuredPersonsAddressList[index] && this.state.InsuredPersonsAddressList[index].latitude) || '',
          longitude: (this.state.InsuredPersonsAddressList[index] && this.state.InsuredPersonsAddressList[index].longitude) || '',
        };
      }


      let insuranceObj = {
        'id': obj.id || 0,
        'patientID': this.props.patientId,
        'insuranceCompanyID': obj.insuranceCompanyID,
        'insuranceCompanyAddress': obj.insuranceCompanyAddress,
        'insuranceIDNumber': obj.insuranceIDNumber,
        'insuranceGroupName': obj.insuranceGroupName,
        'insurancePlanName': obj.insurancePlanName,
        'insurancePlanTypeID': insPlanTypeId,
        'cardIssueDate': obj.cardIssueDate ? moment(obj.cardIssueDate).format('YYYY-MM-DD') : null,
        'cardIssueEndDate': obj.cardIssueEndDate ? moment(obj.cardIssueEndDate).format('YYYY-MM-DD') : null,
        'notes': obj.notes,
        'insurancePersonSameAsPatient': obj.insurancePersonSameAsPatient,
        'carrierPayerID': obj.carrierPayerID,
        'insuredPerson': insuredPerson,
        // 'Base64Front': (obj.insurancePhotoPathThumbFront || '').includes('http') ? '' : obj.insurancePhotoPathThumbFront,
        // 'Base64Back': (obj.insurancePhotoPathThumbBack || '').includes('http') ? '' : obj.insurancePhotoPathThumbBack,
        'Base64Front': '',
        'Base64Back': '',
        'hiddenForFutureTransactions': obj.hiddenForFutureTransactions,
        'authorizedReleasedSignatureId': obj.authorizedReleasedSignatureId || null,
        'authorizedReleasedDate': obj.authorizedReleasedDate ? moment(obj.authorizedReleasedDate).format('YYYY-MM-DD') : null,        
        'authorizedPaymentSignatureId': obj.authorizedPaymentSignatureId || null,
        'insuranceNotes': obj.insuranceNotes ? obj.insuranceNotes.trim() : null,        
        'doNotAcceptAssignment': obj.doNotAcceptAssignment, 
        'additionalClaimInformationBox19':obj.additionalClaimInformationBox19                    
      };
      return insuranceObj;
    });
    // console.log('postData', JSON.stringify(insuranceData));
    this.props.saveInsuranceDetails(insuranceData);
  }

  getNextDay(date){
    if(!date){
      return;
    }
    let selectedDate = new Date(date);
    let nextDate = new Date(selectedDate);
    return nextDate.setDate(selectedDate.getDate() + 1 );
  }

  _getLastSelectedFormIndexByCompanyTypeName(comName){
    let selectedCompanyDatas = this.state.sameSelectedInsureanceIndexsObject[comName];
    if(selectedCompanyDatas && selectedCompanyDatas.length){
      return selectedCompanyDatas[selectedCompanyDatas.length-1];
    }
  }

  _getPrevIndexByInsuranceNameAndIndex(insuranceCompanyName,index){
    let arr = this.state.sameSelectedInsureanceIndexsObject[insuranceCompanyName];
    let lastIndex = 0;
    if(arr && arr.length){
      for(let i=0;i<arr.length;i++){
        if(arr[i]<index){
          lastIndex = arr[i];
        }else{
          break;
        }
      }
    }else{
      return;
    }
    return lastIndex;
  }

  _isFirstInsuranceCompany(insuranceCompanyName,index){
    let arr = this.state.sameSelectedInsureanceIndexsObject[insuranceCompanyName];
    
    if(arr && arr.length){
      for(let i=0;i<arr.length;i++){
        if(arr[i]<index){
         return false;
        }else if(arr[i]==index){
          return true;
        }else{
          return false;
        }
      }
    }
      return true;
  }



  handleNewRequestForInsuranceCompany(input, selectedRecord, filedName, filedName2, insurance,index) {
    let previousCompanyIndex = this._getLastSelectedFormIndexByCompanyTypeName(selectedRecord.label);
    // let isuDate = `insurance[${index}].cardIssueDate`;
    // let expDate = `insurance[${index}].cardIssueEndDate`;
    
    this.setState(
      {
        // [isuDate]:undefined,
        // [expDate]:undefined,
        savedFieldData:
        {
          ...this.state.savedFieldData,
          [filedName]: previousCompanyIndex,
          [filedName2]: selectedRecord.label
        }
      }
      ,()=>{
      this.customValidation(index, selectedRecord.label);
    });
    // this.setState(
    //   {
    //     savedFieldData:
    //     {
    //       ...this.state.savedFieldData,
    //       [filedName2]:selectedRecord.label
    //     }
    //   }
    //   );
    this.handleNewRequest(input, selectedRecord, insurance);
  }

  _createMapWithInsurenceNameWithIteratedIndexes(insurances=[]){
    let newCopy = {};
    if(insurances.length){
      insurances.forEach((insurance,index)=>{
        let insuranceCompName = insurance['insuranceCompanyName'];
        if(insuranceCompName){
          let prevInsuranceIndex = this.state.sameSelectedInsureanceIndexsObject[insurance.insuranceCompanyName] && this.state.sameSelectedInsureanceIndexsObject[insurance.insuranceCompanyName].length  ? this.state.sameSelectedInsureanceIndexsObject[insurance.insuranceCompanyName] : [] ;
          let latestUpdateIndexes = newCopy[insuranceCompName] && newCopy[insuranceCompName].length ? newCopy[insuranceCompName]:[];
          newCopy[insurance.insuranceCompanyName] =  [...new Set([...prevInsuranceIndex,...latestUpdateIndexes, index])];
        }
      })
      this.setState({sameSelectedInsureanceIndexsObject:newCopy});
    }
}



_getIsDisableByIssueAndExpiryDates(formRef,previousCompanyIndex,arr){
  if (!formRef || !formRef.elements) {
    return false;
  }
  
  let issueEndDateElement = formRef.elements[`insurance[${previousCompanyIndex}].cardIssueEndDate`];
  let issueDateElement = formRef.elements[`insurance[${previousCompanyIndex}].cardIssueDate`];

  let issueEndDate = null;
  let issueDate = null;

  if (issueEndDateElement && issueEndDateElement.value) {
    issueEndDate = issueEndDateElement.value.trim();
  }

  if (issueDateElement && issueDateElement.value) {
    issueDate = issueDateElement.value.trim();
  }

  let isDisable = false;
  if(issueDate && issueEndDate && arr && arr.length){
    isDisable = false;
  }else if(issueDate && !issueEndDate  && arr && arr.length){
    isDisable = true;
  } else if(!issueDate && issueEndDate  && arr && arr.length){
    isDisable = true;
  } else if(!issueDate && !issueEndDate  && arr && arr.length){
    isDisable = true;
  } else {
    isDisable = false;
  }
  
  return isDisable;
}

  renderInsuranceDetails = ({ imageFrontPreviewUrl, imageBackPreviewUrl,formRef ,fields }) => {
    const { selectorInsuranceDetail } = this.props;
    this.addRow = () => {

      if(this.props.selectorInsuranceDetail && this.props.selectorInsuranceDetail[0].id === undefined){
        this.setState({
          isAddCollapse : true
        } , () => {
          if(this.state.isAddCollapse){
            showWarningMessage("You can add only one insurance record at a time. Please save the current record before adding another.");
          }
        })

      }else{
       
        if(this.state.isAddNewInsurance){
          showWarningMessage("You can add only one insurance record at a time. Please save the current record before adding another.");
          return;
        }
        fields.push({});
        let fieldName = `insurance[${fields.length}].insuredPerson.countryID`;
        this.props.dispatch(change('InsuranceForm', fieldName, this.props.defaultCountryId));
  
        let patientRelationshipBox6IdfieldName = `insurance[${fields.length}].insuredPerson.patientRelationshipBox6Id`;
        this.props.dispatch(change('InsuranceForm', patientRelationshipBox6IdfieldName, this.props.patientRelationshipBox6Id));
        
        let authorizedReleasedSignatureIdfieldName = `insurance[${fields.length}].authorizedReleasedSignatureId`;
        this.props.dispatch(change('InsuranceForm', authorizedReleasedSignatureIdfieldName, this.props.signatureOnFileId));
  
        let authorizedPaymentSignatureIdfieldName = `insurance[${fields.length}].authorizedPaymentSignatureId`;
        this.props.dispatch(change('InsuranceForm', authorizedPaymentSignatureIdfieldName, this.props.signatureOnFileId));
        this.setState({isAddNewInsurance:true});
      }
   };
    this.removeRow = (index) => {
      // console.log("removeRow");
      let key = `field-${index}`;
      if(this.state.collapseErrors){
        
        // console.log("removeRow first if",this.state.collapseErrors[key]);
        if(this.state.collapseErrors[key]){
          let obj = {...this.state.collapseErrors}
          delete obj[key];
          // console.log("removeRow second if",);
          this.setState({
            collapseErrors:{
              ...obj,
            }
          },()=>{
            if(Object.keys(this.state.collapseErrors).length == 0){
              this.setState({collapseErrors:null})
            }
          })
        }
        if(Object.keys(this.state.collapseErrors).length == 0){
          this.setState({collapseErrors:null})
        }

      }
      if(this.state.showToopTips){
              
        if(this.state.showToopTips[key]){
          let obj = {...this.state.showToopTips}
          delete obj[key];
          this.setState({
            showToopTips:{
              ...obj
            }
          },()=>{
            if(Object.keys(this.state.showToopTips).length == 0){
              this.setState({showToopTips:null})
            }
          })
        }

        if(Object.keys(this.state.showToopTips).length == 0){
          this.setState({showToopTips:null})
        }
      }
      fields.remove(index);
      this.setState({
        isAddNewInsurance : false
      })
    };
    return (
      <div>
        {
          fields.map((insurance, index) => {
            const filedName = `field${index}-prev`;
            const filedName2 = `field${index}-selectedVal`;

            let isDisable = false;            
            let getMinDate = null;
            let defaultValue = null;

            let fromField = null; 
            let value = null;

            let previousCompanyIndex = this.state.savedFieldData[filedName];
            if(index !== 0 ){
                
              if(selectorInsuranceDetail
                && selectorInsuranceDetail[previousCompanyIndex]
                && selectorInsuranceDetail[previousCompanyIndex].cardIssueEndDate){
                defaultValue = selectorInsuranceDetail[previousCompanyIndex].cardIssueEndDate;
              }


              if(fromField){
                 value = fromField;
              }else{
                value = defaultValue;
              }

              getMinDate = this.getNextDay(value);
            }



            let patientInsuranceId = (selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].id),
              insurancePersonSameAsPatient = selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].insurancePersonSameAsPatient,
              relationshipTypeObj = null,
              selectedInsuredPerson = selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].insuredPerson;
            if (selectedInsuredPerson && selectedInsuredPerson.relationshipID) {
              relationshipTypeObj = (this.state.relationship || []).find((masterObj) => selectedInsuredPerson.relationshipID === masterObj.id);
            }

            // this.customValidation(index);
            let myToolTipKey = `field-${index}`;
            let toolTipValue = null;
            if(this.state.showToopTips && this.state.showToopTips[myToolTipKey]){
              toolTipValue = this.state.showToopTips[myToolTipKey]
            }

            let selectedIns = '';
            let previousInsuranceExpDate;
            let isNewInsurance = true ;
            if(this.props.selectorInsuranceDetail && this.props.selectorInsuranceDetail[index] && this.props.selectorInsuranceDetail[index].insuranceCompanyName){
              let previousInsuranceIndex = this._getPrevIndexByInsuranceNameAndIndex(this.props.selectorInsuranceDetail[index].insuranceCompanyName,index);
              isNewInsurance = this._isFirstInsuranceCompany(this.props.selectorInsuranceDetail[index].insuranceCompanyName,index);
              if(previousInsuranceIndex!== null && previousInsuranceIndex !== undefined && this.props.selectorInsuranceDetail && this.props.selectorInsuranceDetail.length){
                let ins = this.props.selectorInsuranceDetail[previousInsuranceIndex];
                if(ins){
                  previousInsuranceExpDate = ins.cardIssueEndDate;
                }
              }
            }
           

            return (
              <InsuranceCollapse 
                index={index}
                filedName={filedName}
                filedName2={filedName2}
                tooltipValue={toolTipValue}
                relationshipTypeObj={relationshipTypeObj}
                selectedInsuredPerson={selectedInsuredPerson}
                patientInsuranceId={patientInsuranceId}
                insurancePersonSameAsPatient={insurancePersonSameAsPatient}
                insurance={insurance}
                renderAutoCompleteSingleSelect={renderAutoCompleteSingleSelect}
                isValidNameWithSpace={isValidNameWithSpace}
                renderTextField={renderTextField}
                renderDateField={renderDateField}
                getMinDate={getMinDate}
                isNewInsurance={isNewInsurance}
                isDisable={index !== 0 ?
                  this._getIsDisableByIssueAndExpiryDates(formRef, previousCompanyIndex, this.state.sameSelectedInsureanceIndexsObject[this.state.savedFieldData[filedName2]]) :
                  false
                }
                selectorInsuranceDetail={selectorInsuranceDetail}
                isValidName={isValidName}
                removeRow={this.removeRow}
                patientMasterData={this.props.patientMasterData}
                _getLastSelectedFormIndexByCompanyTypeName={this._getLastSelectedFormIndexByCompanyTypeName}
                onDateChange={(input,value)=>{
                    // this.customValidation(index, this.props.selectorInsuranceDetail[index].insuranceCompanyName?this.props.selectorInsuranceDetail[index].insuranceCompanyName:'');
                    this.onDateChange(input,value,index);
                  }
                }
                
                previousInsuranceExpDate= {previousInsuranceExpDate}
                // sameCompanyPrevExpDate={this.state.sameSelectedInsureanceIndexsObject[insurance.insuranceCompanyName]}
                cardIssueDate={this.state.cardIssueDate}
                handleNewRequest={this.handleNewRequest}
                masterGender={this.state.masterGender}
                relationship={this.state.relationship}
                isValidAddress={this.state.isValidAddress}
                InsuredPersonsAddressList={this.state.InsuredPersonsAddressList}
                masterCountry={this.state.masterCountry}
                masterState={this.state.masterState}
                insuranceType={this.props.insuranceType}
                GetFullAddress={this.GetFullAddress}
                handleNewRequestForInsuranceCompany={(input, selectedRecord, filedName, filedName2, insurance,index)=>{
                    selectedIns = selectedRecord.label;
                    this.handleNewRequestForInsuranceCompany(input, selectedRecord, filedName, filedName2, insurance,index)
                  }
                }
                cardIssueDateFromInsuranceState={(selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].cardIssueDate)}
                cardIssueEndDateFromInsuranceState={(selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].cardIssueEndDate)}
                secondaryInsuranceArrayLength = {this.props && this.props.selectorInsuranceDetail && this.props.selectorInsuranceDetail.length}
              />
            );

            // return (
            //   <div key={index}>
            //     { index > 0 ?
            //       (<div className="row">
            //         <div className="col-sm-6">
            //           <div className="panel_title">
            //             <h3>Additional Primary Insurance Detail</h3>
            //             <i className="flaticon flaticon-medical-2"></i>
            //             {!patientInsuranceId ?
            //               (<div className="additionalAddressBtn">
            //                 <button className="addnum" type="button" title="Remove Insurance" onClick={() => this.removeRow(index)}>
            //                   <i className="fa fa-minus-square redfont" aria-hidden="true"></i>
            //                 </button>
            //               </div>)
            //               : null}
            //           </div>
            //         </div>
            //       </div>)
            //       : null
            //     }
            //     <div className="row">
            //       <div className="col-sm-4 require mt-35">
            //         <Field
            //           name={`${insurance}.insuranceCompanyID`}
            //           label="Insurance Company"
            //           disabled={patientInsuranceId ? true : false}
            //           options={this.props.patientMasterData && this.props.patientMasterData.insuranceCompanies ? this.props.patientMasterData.insuranceCompanies : []}
            //           handleNewRequest={(input, selectedRecord) => {
            //             let previousCompanyIndex = this._getLastSelectedFormIndexByCompanyTypeName(selectedRecord.label);
            //             this.setState({[filedName]:previousCompanyIndex});
            //             this.setState({[filedName2]:selectedRecord.label});
            //             this.handleNewRequest(input, selectedRecord, insurance);
            //           }}
            //           component={renderAutoCompleteSingleSelect} />
            //       </div>
            //       <div className="col-sm-8">
            //         <Field
            //           name={`${insurance}.insuranceCompanyAddress`}
            //           type="text"
            //           maxLength="55"
            //           label="Insurance Company Address"
            //           normalize={isValidNameWithSpace}
            //           disabled={true}
            //           fullWidth={true}
            //           component={renderTextField} />
            //       </div>
            //     </div>
            //     <div className="row">
            //       <div className="col-sm-4">
            //         <Field
            //           name={`${insurance}.carrierPayerID`}
            //           type="text"
            //           maxLength="100"
            //           disabled={true}
            //           label="Carrier Payer ID"
            //           component={renderTextField} />
            //       </div>
            //       <div className="col-sm-4 ">
            //         <Field
            //           name={`${insurance}.cardIssueDate`}
            //           placeholder="Insurance Issue Date"
            //           component={renderDateField}
            //           openToYearSelection={true}
            //           locale="en-US"
            //           minDate={getMinDate}
            //           disabled={isDisable}
            //           // maxDate={new Date()}
            //           selected={(selectorInsuranceDetail
            //             && selectorInsuranceDetail[index]
            //             && selectorInsuranceDetail[index].cardIssueDate
            //             // && this.getNextDay(selectorInsuranceDetail[index].cardIssueDate)
            //             ) || null}
            //           onDateChange={this.onDateChange} />
            //       </div>
            //       <div className="col-sm-4 ">
            //         <Field
            //           name={`${insurance}.cardIssueEndDate`}
            //           placeholder="Insurance Expiry date"
            //           component={renderDateField}
            //           openToYearSelection={true}
            //           locale="en-US"
            //           disabled={isDisable}
            //           minDate ={this.state.cardIssueDate || (selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].cardIssueDate) || null}
            //           // maxDate={new Date()}
            //           selected={(selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].cardIssueEndDate) || null}    
            //           onDateChange={this.onDateChange} />
            //       </div>
            //     </div>
            //     <div className="row">
            //       <div className="col-sm-4">
            //         <Field
            //           name={`${insurance}.insuranceGroupName`}
            //           type="text"
            //           normalize={isValidNameWithSpace}
            //           maxLength="30"
            //           label="Insurance Group Name/Number"
            //           component={renderTextField} />
            //       </div>
            //       <div className="col-sm-4">
            //         <Field
            //           name={`${insurance}.insurancePlanName`}
            //           type="text"
            //           normalize={isValidNameWithSpace}
            //           maxLength="50"
            //           label="Insurance Plan Name"
            //           component={renderTextField} />
            //       </div>
            //       <div className="col-sm-4 require">
            //         <Field
            //           name={`${insurance}.insuranceIDNumber`}
            //           type="text"
            //           normalize={isValidNameWithSpace}
            //           maxLength="20"
            //           label="Insurance ID Number"
            //           component={renderTextField} />
            //       </div>
            //     </div>
            //     <div className="row">  
            //       <div className="col-sm-4">
            //         <Field
            //           name={`${insurance}.notes`}
            //           type="text"
            //           maxLength="100"
            //           label={`${(this.props.insuranceType || '').charAt(0).toUpperCase() + (this.props.insuranceType || '').substr(1)} Insurance Notes`}
            //           fullWidth={true}
            //           component={renderTextField} />
            //       </div>                
            //       <div className="col-sm-4 mt-35">
            //         <Field
            //           name={`${insurance}.authorizedReleasedSignatureId`}
            //           label="Authorized Release (Box 12)" 
            //           options={this.props.patientMasterData && this.props.patientMasterData.signatureOnFile ? this.props.patientMasterData.signatureOnFile : []}
            //           handleNewRequest={(input, selectedRecord) => this.handleNewRequest(input, selectedRecord, insurance)}
            //           component={renderAutoCompleteSingleSelect} />
            //       </div>
            //       <div className="col-sm-4">
            //         <Field
            //           name={`${insurance}.authorizedReleasedDate`}
            //           placeholder="Date Of Signature"
            //           component={renderDateField}
            //           openToYearSelection={true}
            //           locale="en-US"
            //           maxDate={new Date()}
            //           selected={(selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].authorizedReleasedDate) || new Date()}
            //           onDateChange={this.onDateChange} />
            //       </div>                 
            //     </div> 
            //     <div className="row">
            //       <div className="col-sm-4 mt-35">
            //         <Field
            //           name={`${insurance}.authorizedPaymentSignatureId`}
            //           label="Authorized Payment (Box 13)"     
            //           options={this.props.patientMasterData && this.props.patientMasterData.signatureOnFile ? this.props.patientMasterData.signatureOnFile : []}
            //           handleNewRequest={(input, selectedRecord) => this.handleNewRequest(input, selectedRecord, insurance)}
            //           component={renderAutoCompleteSingleSelect} />
            //       </div>   
            //     </div>
            //     <div className="row">
            //       <div className="col-sm-12 custm_clientinsurance">
            //         <span>If "No Signature on File" is selected for Box 12 and/or 13 then claims may be denied. Please make sure you have all necessary signatures on file prior to submission of claims.</span>
            //       </div>
            //     </div>
            //     <div className="row">                  
            //       <div className="col-sm-12 mt-20 custm_clientinsurance">
            //         <Field
            //             name={`${insurance}.doNotAcceptAssignment`}
            //             label='Do Not Accept Assignment (Box 27)'
            //             component={renderCheckBox}
            //           />
            //           <span>(If "Do Not Accept Assignment" is checked then Theralytics will select “No” for Box 27. This box should not be checked unless payment should go to the client instead of your organization.)</span>
            //       </div>                  
            //     </div>
            //     <div className="row">                  
            //       <div className="col-sm-12">
            //         <Field
            //           name={`${insurance}.insuranceNotes`}                      
            //           type="text"
            //           fullWidth={true}
            //           label="Insurance Notes"
            //           // autoHeight={true}                      
            //           component={renderTextArea}                      
            //         />
            //       </div>
            //     </div>
            //     <br />
            //     <div className="row">
            //       <div className="col-sm-6 custm_clientinsurance">
            //         <Field
            //           name={`${insurance}.insurancePersonSameAsPatient`}
            //           label='Insured Person is the same person as the Client'
            //           component={renderCheckBox}
            //         />
            //         <span>(If this box is checked then Theralytics will select "Self" in box 6 of the CMS 1500 form.)</span>
            //       </div>
            //       <div className="col-sm-6 custm_clientinsurance">
            //         <Field
            //             name={`${insurance}.hiddenForFutureTransactions`}
            //             label='Delete Insurance'
            //             component={renderCheckBox}
            //           />
            //           <span>(Please make sure to end any existing authorizations with this payer. This payer will no longer be available once this box is checked and saved.)</span>
            //       </div>
            //     </div>               
            //     {!insurancePersonSameAsPatient ?
            //       <div>
            //         <div className="panel_title">
            //           <i className="flaticon flaticon-shield"></i>
            //           <h3>Insured person {insurancePersonSameAsPatient} </h3>
            //         </div>
            //         <div className="row">
            //           <div className="col-sm-4 require">
            //             <Field
            //               name={`${insurance}.insuredPerson.firstName`}
            //               type="text"
            //               maxLength="40"
            //               normalize={isValidName}
            //               label="First Name"
            //               component={renderTextField} />
            //           </div>
            //           <div className="col-sm-4">
            //             <Field
            //               name={`${insurance}.insuredPerson.middleName`}
            //               type="text"
            //               maxLength="40"
            //               normalize={isValidName}
            //               label="Middle Name"
            //               component={renderTextField} />
            //           </div>
            //           <div className="col-sm-4 require">
            //             <Field
            //               name={`${insurance}.insuredPerson.lastName`}
            //               type="text"
            //               maxLength="40"
            //               normalize={isValidName}
            //               label="Last Name"
            //               component={renderTextField} />
            //           </div>
            //         </div>
            //         <div className="row">
            //           <div className="col-sm-4 require mt-35">
            //             <Field
            //               name={`${insurance}.insuredPerson.genderID`}
            //               label="Gender"
            //               handleNewRequest={this.handleNewRequest}
            //               options={this.state.masterGender}
            //               component={renderAutoCompleteSingleSelect} />
            //           </div>
            //           <div className="col-sm-4 require">
            //             <Field
            //               name={`${insurance}.insuredPerson.dob`}
            //               placeholder="Date of birth"
            //               component={renderDateField}
            //               openToYearSelection={true}
            //               locale="en-US"
            //               maxDate={new Date()}
            //               selected={(selectedInsuredPerson && selectedInsuredPerson.dob) || null}
            //               onDateChange={this.onDateChange} />
            //           </div>
            //           <div className="col-sm-4 require">
            //             <Field
            //               name={`${insurance}.insuredPerson.phone`}
            //               type="text"
            //               maxLength="14"
            //               label="Mobile"
            //               component={renderTextField}
            //               normalize={normalizeMobile} />
            //           </div>
            //         </div>
            //         <div className="row">
            //           <div className="col-sm-4 require mt-35">
            //             <Field
            //               name={`${insurance}.insuredPerson.patientRelationshipBox6Id`}
            //               label="Relationship Status (Box 06)"     
            //               options={this.props.patientMasterData && this.props.patientMasterData.insuredPersonRelationship ? this.props.patientMasterData.insuredPersonRelationship : []}
            //               handleNewRequest={this.handleNewRequest}
            //               component={renderAutoCompleteSingleSelect} />
            //           </div>
            //           <div className="col-sm-4 require mt-35">
            //             <Field
            //               name={`${insurance}.insuredPerson.relationshipID`}
            //               label="Relationship"
            //               handleNewRequest={this.handleNewRequest}
            //               options={this.state.relationship}
            //               component={renderAutoCompleteSingleSelect} />
            //           </div>
            //           {
            //             relationshipTypeObj && relationshipTypeObj.value && relationshipTypeObj.value.toUpperCase() === 'OTHER' ?
            //               <div className="col-sm-4 require">
            //                 <Field
            //                   name={`${insurance}.insuredPerson.otherRelationshipName`}
            //                   label='Mention Other Relationship'
            //                   component={renderTextField}
            //                 />
            //               </div>
            //               : null
            //           }
            //         </div>
            //         <div className="row">
            //           <div className="col-sm-8 require">
            //             <GooglePlaceAutocomplete
            //               getFullAddress={(componentForm) => this.GetFullAddress(componentForm, index)}
            //               id={`${insurance}.insuredPerson.Address`}
            //               labelText="Address"
            //               errorText={this.state.isValidAddress ? '' : 'Please enter address.'}
            //               value={this.state.InsuredPersonsAddressList && this.state.InsuredPersonsAddressList[index] && this.state.InsuredPersonsAddressList[index].address}
            //             />
            //           </div>
            //           <div className="col-sm-4">
            //             <Field
            //               name={`${insurance}.insuredPerson.apartmentNumber`}
            //               type="text"
            //               maxLength='15'
            //               label="Apt/Unit"
            //               normalize={isValidApartmentWithSpace}
            //               component={renderTextField} />
            //           </div>
            //         </div>
            //         <div className="row">
            //           <div className="col-sm-4 require mt-35">
            //             <Field
            //               name={`${insurance}.insuredPerson.countryID`}
            //               label="Country"
            //               options={this.state.masterCountry}
            //               handleNewRequest={(input, selectedRecord) => this.handleNewRequest(input, selectedRecord, insurance)}
            //               component={renderAutoCompleteSingleSelect} />
            //           </div>
            //           <div className="col-sm-4 require">
            //             <Field
            //               name={`${insurance}.insuredPerson.city`}
            //               type="text"
            //               maxLength="50"
            //               normalize={isValidNameWithSpace}
            //               label="City"
            //               component={renderTextField} />
            //           </div>
            //           <div className="col-sm-4 require mt-35">
            //             <Field
            //               name={`${insurance}.insuredPerson.stateID`}
            //               label="State"
            //               disabled={!(selectedInsuredPerson && selectedInsuredPerson.countryID)}
            //              // options={this.state.filteredStatesByCountry[index]}
            //               options={this.state.masterState.filter((obj) => obj.countryID === 1)}                         
            //               handleNewRequest={this.handleNewRequest}
            //               component={renderAutoCompleteSingleSelect} />
            //           </div>
            //         </div>
            //         <div className="row">
            //           <div className="col-sm-4 require">
            //             <Field
            //               name={`${insurance}.insuredPerson.zip`}
            //               type="text"
            //               maxLength="10"
            //               normalize={normalizeZipCode}
            //               label="Zip"
            //               component={renderTextField} />
            //           </div>
            //         </div>
            //       </div>
            //       : ''}
            //     {/* <div className="row">
            //       <div className="col-sm-3">
            //         <div className="uplaod_pic">
            //           <FlatButton label="Upload" className="browse" labelPosition="before" style={styles.uploadButton}
            //             containerElement="label" fullWidth={true}>
            //             <i className="fa fa-cloud-upload fa-2x" aria-hidden="true"></i>
            //             <Field
            //               name={`${insurance}.InsurancePhotoPathThumbFront`}
            //               type="file"
            //               style={styles.uploadInput}
            //               component={renderUploadField}
            //               onChange={(e) => this._handleImageChange(e, 'front', index)}
            //               label="Client Photo" />
            //           </FlatButton>
            //         </div>
            //         <p className="ins_photo">Please upload insurance front picture.<br />(jpg, jpeg, bmp, png)</p>
            //       </div>
            //       <div className="col-sm-3">
            //         <div>
            //           {selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].insurancePhotoPathThumbFront ?
            //             <div className="insimage">
            //               <img title="Insurance front image" src={selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].insurancePhotoPathThumbFront}
            //                 alt={selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].insurancePhotoPathThumbFront} />
            //               <b onClick={(e) => this.handleRemoveImage(e, 'front', index)} className="fa fa-times-circle valuefont"
            //                 aria-hidden="true"></b>
            //             </div>
            //             : null
            //           }
            //         </div>
            //       </div>
            //       <div className="col-sm-3">
            //         <div className="uplaod_pic">
            //           <FlatButton label="Upload" className="browse" labelPosition="before" style={styles.uploadButton}
            //             containerElement="label" fullWidth={true}>
            //             <i className="fa fa-cloud-upload fa-2x" aria-hidden="true"></i>
            //             <Field
            //               name={`${insurance}.InsurancePhotoPathThumbFront`}
            //               type="file"
            //               style={styles.uploadInput}
            //               component={renderUploadField}
            //               onChange={(e) => this._handleImageChange(e, 'back', index)}
            //               label="Client Photo" />
            //           </FlatButton>
            //         </div>
            //         <p className="ins_photo">Please upload insurance back picture.<br />(jpg, jpeg, bmp, png)</p>
            //       </div>
            //       <div className="col-sm-3">
            //         <div>
            //           {selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].insurancePhotoPathThumbBack ?
            //             <div className="insimage">
            //               <img title="Insurance back image" src={selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].insurancePhotoPathThumbBack}
            //                 alt={selectorInsuranceDetail && selectorInsuranceDetail[index] && selectorInsuranceDetail[index].insurancePhotoPathThumbBack} />
            //               <b onClick={(e) => this.handleRemoveImage(e, 'back', index)} className="fa fa-times-circle valuefont"
            //                 aria-hidden="true"></b>
            //             </div>
            //             : null
            //           }
            //         </div>
            //       </div>
            //     </div> */}
            //   </div>
            // );
          })
        }
        { this.props.insuranceType === 'primary' ?
          (<div className="row">
            <div className="col-sm-6">
              <div className="panel_title">
              <h3>ADD ADDITIONAL PRIMARY INSURANCE</h3>
                <i className="flaticon flaticon-medical-2"></i>
                <div className="additionalAddressBtn">
                  <button className="addnum" type="button" title="Add Insurance" onClick={() => this.addRow()}>
                    <i className="fa fa-plus-square greenfont" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>)
          : null
        }
        {this.props.insuranceType === 'secondary' ?
          (<div className="row">
            <div className="col-sm-6">
              <div className="panel_title">
                <h3>ADD ADDITIONAL SECONDARY INSURANCE</h3>
                <i className="flaticon flaticon-medical-2"></i>
                <div className="additionalAddressBtn">
                  <button className="addnum" type="button" title="Add Insurance" onClick={() => this.addRow()}>
                    <i className="fa fa-plus-square greenfont" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>)
          : null
        }
      </div>
    );
  }


  currentDateIsValid(){
   let keys =  Object.keys(this.state.savedFieldData || {});
   if(keys.length &&  this.state.collapseErrors && Object.keys(this.state.collapseErrors).length){
     let myarr = keys.map(key=>{
     let arr = key.split("-")[0].split('');
      return arr[arr.length-1];
     });
     myarr = [...new Set(myarr)];
  
     if(myarr && myarr.length){
      let flag = myarr.every(val=>{
        let insurance = this.props.selectorInsuranceDetail[val];
        return (insurance.cardIssueDate && insurance.cardIssueDate);
      })
      return flag;
     }else{
      return false;
     }
   }else{
    return true;
   }
  }

  
  checkDateInValid(){
    if(this.state.collapseErrors){
      let keys = Object.keys(this.state.collapseErrors);
      let valids = {};
      let invalids = [];
      keys.forEach(key=>{
        if(this.state.collapseErrors[key] && this.state.collapseErrors[key] === "invalid"){
          valids[key] = "invalid";
          invalids.push(true);
        }else {
          valids[key] = null;
        }
      });
      
      // this.setState({
      //   showToopTips: null
      // },()=>{
        this.setState({showToopTips:valids})
      // })
      
      if(invalids.length){
        return invalids.every(value=>{
          return value === true;
        })
      }else{
        return false;
      }
    }else{
      // this.setState({
      //   showToopTips: null
      // });
      return false;
    }
  }


  render() {
    // console.log("length of the insurance=========>>" , this.props.selectorInsuranceDetail.length)
    const { handleSubmit } = this.props;
    return (
      <div>
        <form className="readmin-form custom_form" ref={this.setFormRef} noValidate onSubmit={(e)=>{
              e.preventDefault()
              let flag = this.checkDateInValid();
              
              // console.log("onSubmit",flag);
              if(!flag){
                ////////////////////////////// Date validation////////////
                // let flag2 = this.currentDateIsValid(); 
                // if(flag2){
                //   handleSubmit(this.onSubmit.bind(this))(e);
                // } else {
                //   showWarningMessage("Please enter the issue date and expiration date for current Insurance ");  
                // }
                //////////////////////////////////////////
                handleSubmit(this.onSubmit.bind(this))(e);
                
              } else {
                showWarningMessage("Please enter the issue date and expiration date for the previously added insurance with the same name.");
              }
            }
          }>
          {this.props.insuranceType === 'tertiary' ?
            <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3 style={styles.font}><b>*At this time, Theralytics does not support submission of Tertiary claims. You can enter Tertiary insurance information for reference only</b></h3>
                  </div>
                </div>
              </div>
          : null}
          <FieldArray
            name="insurance"
            mystate={this.state}
            formRef={this.formRef}
            imageFrontPreviewUrl={this.state.imageFrontPreviewUrl}
            imageBackPreviewUrl={this.state.imageBackPreviewUrl}
            component={this.renderInsuranceDetails}
              />
          <div className="row">
            <div className="col-sm-12 pt20 btn_rt">
              <CommonButton type="submit" primary={true} disabled={this.props.loading ? true : false} label={`${this.props.loading ? 'Loading' : 'Save' }`}/>
              <CommonButton className="ml_15" primary={true} disabled={this.props.loading ? true : false} label={'Save & Continue'} onTouchTap={(e)=>{
                    e.preventDefault()
                    let flag = this.checkDateInValid();
                    this.currentDateIsValid();
                    
                    // console.log("onSubmit",flag);
                    if(!flag){
                      let flag2 = this.currentDateIsValid();
                      if(flag2){
                        handleSubmit(this.handleSaveContinue.bind(this))(e);
                      } else {
                        showWarningMessage("Please enter the issue date and expiration date for current Insurance ");  
                      }
                      
                      // handleSubmit(this.onSubmit)(e)
                    } else {
                      showWarningMessage("Please enter the issue date and expiration date for the previously added insurance with the same name.");
                    }
                  }
                } />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

// Decorate with connect to read form values
const selector = formValueSelector('InsuranceForm'); // <-- same as form name

function mapStateToProps(state, ownProps) {
  let agencyName = state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '';
  let countryName = agencyName.toUpperCase() === CONVERGENCY ? 'Canada' : 'US';

  let defaultCountryId = state.patient.patientMasterData ? (state.patient.patientMasterData.masterCountry || []).find((obj) => obj.countryName === countryName).id : null,
  patientRelationshipBox6Id = state.patient.patientMasterData ? (state.patient.patientMasterData.insuredPersonRelationship || []).find((obj) => obj.globalCodeValue === 'Other').id : null,
    initialValueData = {
      'insurance': [{
        'insuredPerson': { countryID: defaultCountryId, patientRelationshipBox6Id: patientRelationshipBox6Id,  },
        authorizedReleasedSignatureId: (state.patient.patientMasterData && state.patient.patientMasterData.signatureOnFile ? state.patient.patientMasterData.signatureOnFile[0].id : []),
        authorizedPaymentSignatureId: (state.patient.patientMasterData && state.patient.patientMasterData.signatureOnFile ? state.patient.patientMasterData.signatureOnFile[0].id : []),
      }],
    };

  initialValueData = {
    ...initialValueData,
    ...ownProps.currentInsuranceDetails,
  };

  // console.log('initialValuesData.............', initialValueData);

  return {
    defaultCountryId,
    patientRelationshipBox6Id,
    loading: state.patient.loading,
    patientMasterData: state.patient.patientMasterData,
    initialValues: initialValueData,
    // patientInsuranceDetails: patientInsuranceDetails,
    // currentInsuranceDetails: owncurrentInsuranceDetails,
    saved_patientInsuranceDetails: state.patient.saved_patientInsuranceDetails,
    selectorInsuranceDetail: selector(state, 'insurance'),
    signatureOnFileId: (state.patient.patientMasterData && state.patient.patientMasterData.signatureOnFile ? state.patient.patientMasterData.signatureOnFile[0].id : [])
    // saving: state.patient.saving,
  };
}

// connect: first agrument is mapStateToProps, 2nd argument is mapDispatchToProps
// reduxForm: first is form config, 2nd is mapStateToProps, 3rd is mapDispatchToProps
InsuranceForm = reduxForm({
  form: 'InsuranceForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(InsuranceForm);
export default connect(mapStateToProps, {
  getMasterData,
  getPatientInsurancesDetails,
  saveInsuranceDetails,
})(InsuranceForm);



// WEBPACK FOOTER //
// ./src/modules/patients/insurance_form.js